module.exports = __webpack_public_path__ + "img/MoneyCritical.68b94daa.svg";